import type { ReactNode } from "react";
import { Empty, Flex, Typography } from "antd";

/**
 * Trạng thái rỗng (UIUX §3 Empty): thông điệp + hướng hành động tiếp theo —
 * màn trống luôn có đường đi, không bỏ người dùng giữa chừng.
 */
export function EmptyState({ title, description, action }: {
  readonly title: string;
  readonly description?: string;
  readonly action?: ReactNode;
}) {
  return (
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      description={
        <Flex vertical gap="none" align="center">
          <Typography.Text strong>{title}</Typography.Text>
          {description ? <Typography.Text type="secondary">{description}</Typography.Text> : null}
        </Flex>
      }
    >
      {action}
    </Empty>
  );
}
